/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import CloseAction from './CloseAction/index'
import Editor from './Editor/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import ResetAction from './ResetAction/index'
import RetakeAction from './RetakeAction/index'
import SaveAction from './SaveAction/index'
import SubmittingInfo from './SubmittingInfo/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/Edit/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let imageSlotKeyValueData = fromData.useDataFormat({ viewPath,
context: 'image',
path: 'slot_key',
format: fromFormat.getPatientImageName,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="98%"
 height="98%"
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 data="image.slot_key"
 format="/Data/format.js getPatientImageName"
 text={imageSlotKeyValueData}
 level="h2"
 marginBottom={dtSpaceXs}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Editor
{...childProps}
  viewPath={`${viewPath}/Editor`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
<ResetAction
  viewPath={`${viewPath}/ResetAction`}
/>
<RetakeAction
  viewPath={`${viewPath}/RetakeAction`}
/>
</div>
<SubmittingInfo
{...childProps}
  viewPath={`${viewPath}/SubmittingInfo`}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}